import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TextInput } from './text-input';
import { styled } from '../stitches.config';
export const ColorInput = styled(React.forwardRef(function ColorInput({ onValue, ...props }, ref) {
    return (_jsx(TextInput, { ...props, onValue: (value) => {
            if (validHex(value) && onValue) {
                onValue(`#${escapeHex(value)}`);
            }
        }, spellCheck: false, ref: ref }));
}));
const matcher = /^#?([0-9A-F]{3,8})$/i;
const validHex = (value, alpha) => {
    const match = matcher.exec(value);
    const length = match ? match[1].length : 0;
    return (length === 3 || // '#rgb' format
        length === 6 || // '#rrggbb' format
        (!!alpha && length === 4) || // '#rgba' format
        (!!alpha && length === 8) // '#rrggbbaa' format
    );
};
const escapeHex = (value) => value.replace(/([^0-9A-F]+)/gi, '').substr(0, 6);
//# sourceMappingURL=color-input.js.map